@let pedido = pendencia();

<article class="complemento" [attr.aria-labelledby]="prefixoId + '-titulo'">
  <header class="complemento-cabecalho">
    <h4 class="complemento-titulo" [id]="prefixoId + '-titulo'">
      <i-lucide name="message-circle-question" size="20" aria-hidden="true"></i-lucide>
      O órgão pediu um complemento
    </h4>

    <p class="complemento-meta">
      <span class="visually-hidden">Pedido em</span>
      {{ pedido.pedidaEm }}
    </p>
  </header>

  <p class="complemento-mensagem">{{ pedido.mensagem }}</p>

  @if (pedido.limite) {
    <p class="complemento-limite">
      <i-lucide name="clock" size="16" aria-hidden="true"></i-lucide>
      Envie até {{ pedido.limite }}
    </p>
  }

  <!-- O formulário fica fora do PDF de /acompanhamento: no papel, só o pedido do órgão faz sentido. -->
  <form class="complemento-form" novalidate data-html2canvas-ignore (submit)="enviar($event)">
    @if (erro(); as falha) {
      <div class="complemento-erro" role="alert">
        <i-lucide name="circle-alert" size="18" aria-hidden="true"></i-lucide>
        <div>
          <p class="complemento-erro-mensagem">{{ falha.mensagem }}</p>
          @if (falha.detalhes.length) {
            <ul class="complemento-erro-detalhes">
              @for (detalhe of falha.detalhes; track $index) {
                <li>{{ detalhe }}</li>
              }
            </ul>
          }
        </div>
      </div>
    }

    <div class="complemento-campo">
      <label class="complemento-rotulo" [for]="prefixoId + '-texto'">
        Seu complemento <span class="complemento-obrigatorio" aria-hidden="true">*</span>
      </label>

      <textarea
        class="complemento-textarea"
        rows="5"
        placeholder="Escreva aqui o que o órgão pediu..."
        [id]="prefixoId + '-texto'"
        [attr.aria-describedby]="prefixoId + '-contador'"
        [formField]="complementoForm.texto"
      ></textarea>

      <div class="complemento-texto-rodape">
        @if (complementoForm.texto().touched() && complementoForm.texto().invalid()) {
          <p class="complemento-erro-campo">{{ complementoForm.texto().errors()[0]?.message ?? 'Campo obrigatório.' }}</p>
        }

        <p class="complemento-contador" [id]="prefixoId + '-contador'">{{ caracteres() }}/{{ limiteTexto }}</p>
      </div>
    </div>

    <div class="complemento-campo">
      <span class="complemento-rotulo">Anexos (opcional)</span>
      <p class="complemento-ajuda">
        Até {{ limiteAnexos }} arquivos {{ descricaoFormatos }}, com até {{ tetoAnexo }} cada.
      </p>

      <label class="complemento-adicionar" [attr.data-desabilitado]="limiteAtingido() || enviando()">
        <i-lucide name="paperclip" size="16" aria-hidden="true"></i-lucide>
        Adicionar arquivos
        <input
          type="file"
          class="visually-hidden"
          multiple
          [attr.accept]="accept"
          [disabled]="limiteAtingido() || enviando()"
          (change)="aoSelecionar($event)"
        />
      </label>

      @if (recusas().length) {
        <ul class="complemento-recusas" role="alert">
          @for (recusa of recusas(); track $index) {
            <li>{{ recusa }}</li>
          }
        </ul>
      }

      @if (arquivos().length) {
        <ul class="complemento-arquivos">
          @for (item of arquivos(); track item.id) {
            <li class="complemento-arquivo">
              <i-lucide class="complemento-arquivo-icone" name="file" size="18" aria-hidden="true"></i-lucide>

              <span class="complemento-arquivo-texto">
                <strong>{{ item.arquivo.name }}</strong>
                <span>{{ item.tamanho }}</span>
              </span>

              <button
                type="button"
                class="complemento-remover"
                [disabled]="enviando()"
                [attr.aria-label]="'Remover ' + item.arquivo.name"
                (click)="remover(item.id)"
              >
                <i-lucide name="x" size="16" aria-hidden="true"></i-lucide>
              </button>
            </li>
          }
        </ul>
      }
    </div>

    <div class="complemento-acoes">
      <button type="submit" class="complemento-enviar" [disabled]="enviando()" [attr.aria-busy]="enviando()">
        <i-lucide name="send" size="16" aria-hidden="true"></i-lucide>
        {{ enviando() ? 'Enviando...' : 'Enviar complemento' }}
      </button>
    </div>
  </form>
</article>
